import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/CadastrarPilotoMototaxi.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { cadastrarPilotoMototaxi } from '../servicos/cadastroServico';
import { aplicarMascaraTelefone } from '../uteis/mascaras/mascaraTelefone';


const valoresIniciais = {
  nome: '',
  email: '',
  senha: '',
  confirma_senha: '',
  // status_piloto_id: '',
  latitude: '',
  longitude: '',
  numero_celular_com_ddd: '',
  marca_moto: '',
  modelo_moto: '',
  ano_moto: '',
  cor_moto: '',
  placa_moto: '',
  st_is_ativo: true,
  observacao: '',
  servicos: [],
  data_inicio_vigencia: '',
  data_fim_vigencia: '',
  st_is_vigente: true,
  ponto_mototaxi_id: null
};

const listaServicos = [
  { id: 1, nome: 'moto-taxi', descricao: 'Serviço de transporte de passageiros' },
  { id: 2, nome: 'encomendas-pequenas', descricao: 'Entrega de pequenas encomendas' },
  { id: 3, nome: 'gas', descricao: 'Entrega de gás' },
  { id: 4, nome: 'cimento', descricao: 'Entrega de cimento e materiais de construção' },
  { id: 5, nome: 'cerveja', descricao: 'Entrega de bebidas' },
  { id: 6, nome: 'compras', descricao: 'Serviço de compras em geral' },
  { id: 7, nome: 'banco', descricao: 'Serviço de ida ao banco' }
];

function CadastrarPilotoMototaxi() {

  const [form, setForm] = useState(valoresIniciais);
  const navigate = useNavigate();

  useEffect(() => {

    console.log('Entrou no useEffect do cadastrar piloto...');

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setForm((prevForm) => ({
            ...prevForm,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }));
        },
        (error) => {
          console.error('Erro ao obter localização:', error);
        }
      );
    } else {
      console.error('Geolocalização não suportada pelo navegador.');
    }
  }, []);
  



  // ✅ Mostra os cookies no console ao carregar o componente
  useEffect(() => {

    console.log('Entrou no useEffect do Cadastrar Piloto Mototaxi.... cookies...');

    const cookies = Cookies.get(); // retorna objeto
    //  com todos os cookies
    const dadosCookiesString = cookies.dadosCookies;

    if (dadosCookiesString) {
        try {
            const dadosCookies = JSON.parse(dadosCookiesString); // transforma string em objeto
            // const dadosUsuario = dadosCookies.dadosUsuario;
            // const perfis = dadosCookies.perfis;
            const dadosPontoMototaxi = dadosCookies.dadosPontoMototaxi;
            const idPontoMototaxi = dadosPontoMototaxi.id;
            
            // vamos setar o id do representante comercial logado
            setForm((prevForm) => ({
                ...prevForm,
                ponto_mototaxi_id: idPontoMototaxi
            }));                  

            console.log('Dados cookies:', dadosCookies);
            console.log('Dados ponto mototaxi:', dadosPontoMototaxi);
            console.log('id ponto mototaxi:', idPontoMototaxi);
            // console.log('Dados usuário:', dadosUsuario);
            // console.log('Dados representante comercial', dadosRepresentanteComercial);
            // console.log('Id representante comercial', idRepresentanteComercial);
            // console.log('Perfis:', perfis);
        } catch (e) {
            console.error('Erro ao fazer parse dos dadosCookies:', e);
        }
    } else {
        console.warn('Cookie "dadosCookies" não encontrado');
    }
}, []);





  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === 'checkbox' ? checked : value;

    if (name === 'servicos') {
      const servicoSelecionado = Number(value);
      const novosServicos = checked
        ? [...form.servicos, servicoSelecionado]
        : form.servicos.filter((s) => s !== servicoSelecionado);
      setForm((prevForm) => ({ ...prevForm, servicos: novosServicos }));
      return;
    }

    setForm((prevForm) => ({
      ...prevForm,
      [name]: newValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.senha !== form.confirma_senha) {
      alert("As senhas não coincidem!");
      return;
    }

    try {
      await cadastrarPilotoMototaxi(form);
      alert('Piloto de Mototáxi cadastrado com sucesso!');
      setForm(valoresIniciais);
      navigate('/listar-piloto-mototaxi');
    } catch (erro) {
      alert('Erro ao cadastrar piloto.');
      console.error(erro);
    }
  };

  return (
    <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '600px', margin: '2rem auto' }}>
      <div className="card-body">
        <h3 className="text-center mb-4">Cadastrar Piloto de Mototáxi</h3>

        <form onSubmit={handleSubmit}>
        {[
          ['nome', 'Nome'],
          ['email', 'E-mail'],
          ['senha', 'Senha'],
          ['confirma_senha', 'Confirmar Senha'],
          ['marca_moto', 'Marca da Moto'],
          ['modelo_moto', 'Modelo da Moto'],
          ['ano_moto', 'Ano da Moto'],
          ['cor_moto', 'Cor da Moto'],
          ['placa_moto', 'Placa da Moto']
        ].map(([field, label]) => (
          <div className="form-floating mb-3" key={field}>
            <input
              type={field.includes('senha') ? 'password' : 'text'}
              className="form-control"
              id={field}
              name={field}
              placeholder={label}
              value={form[field]}
              onChange={handleChange}
              required
            />
            <label htmlFor={field}>{label}</label>
          </div>
        ))}




            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="numeroCelular"
                name="numero_celular_com_ddd"
                // placeholder="(83) 91234-5678"
                value={form.numero_celular_com_ddd}
                onChange={(e) => {
                  const valorFormatado = aplicarMascaraTelefone(e.target.value);
                  setForm((prevForm) => ({
                    ...prevForm,
                    numero_celular_com_ddd: valorFormatado,
                  }));
                }}
                maxLength={15}
                required
              />
              <label htmlFor="numeroCelular">Celular com DDD</label>
            </div>


          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="st_is_ativo"
              name="st_is_ativo"
              checked={form.st_is_ativo}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="st_is_ativo">Ativo</label>
          </div>

          <div className="form-floating mb-3">
            <textarea
              className="form-control"
              id="observacao"
              name="observacao"
              placeholder="Observações"
              value={form.observacao}
              onChange={handleChange}
              style={{ height: '100px' }}
            />
            <label htmlFor="observacao">Observações</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              id="data_inicio_vigencia"
              name="data_inicio_vigencia"
              placeholder="Início da Vigência"
              value={form.data_inicio_vigencia}
              onChange={handleChange}
              required
            />
            <label htmlFor="data_inicio_vigencia">Início da Vigência</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              id="data_fim_vigencia"
              name="data_fim_vigencia"
              placeholder="Fim da Vigência"
              value={form.data_fim_vigencia}
              onChange={handleChange}
            />
            <label htmlFor="data_fim_vigencia">Fim da Vigência</label>
          </div>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="st_is_vigente"
              name="st_is_vigente"
              checked={form.st_is_vigente}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="st_is_vigente">Vigente</label>
          </div>

          <h5 className="mb-2 mt-4">Serviços oferecidos:</h5>
          <div className="mb-4 border p-3 rounded">
            <div className="row">
              {listaServicos.map((servico) => (
                <div className="col-6 col-md-4 mb-2" key={servico.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`servico-${servico.id}`}
                      name="servicos"
                      value={servico.id}
                      checked={form.servicos.includes(servico.id)}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor={`servico-${servico.id}`}>
                      {servico.nome}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>


          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="latitude"
              name="latitude"
              value={form.latitude}
              placeholder="Latitude"
              readOnly
            />
            <label htmlFor="latitude">Latitude</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="longitude"
              name="longitude"
              value={form.longitude}
              placeholder="Longitude"
              readOnly
            />
            <label htmlFor="longitude">Longitude</label>
          </div>

          <button type="submit" className="btn btn-primary w-100">Salvar Piloto</button>
        </form>
      </div>
    </div>
  );
}

export default CadastrarPilotoMototaxi;
